import React, { useState, Fragment, Component } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogOutIcon, LayoutDashboardIcon, GraduationCapIcon, UsersIcon, CalendarIcon, MailIcon, BarChart3Icon, SettingsIcon, BellIcon, UserIcon, ChevronDownIcon, ShieldIcon, BuildingIcon, HomeIcon, ChevronLeftIcon, MenuIcon, XIcon, FileTextIcon, PlusCircleIcon, BookOpenIcon, AwardIcon, GlobeIcon, CheckSquareIcon } from 'lucide-react';
import { theme } from '../styles/theme';
interface LayoutProps {
  children: React.ReactNode;
  title: string;
  persona: string;
  universityName?: string;
}
// Define the navigation item type
interface NavItem {
  label: string;
  icon: React.ReactNode;
  path: string;
  badge?: string | number;
}
// Student Navbar Component
const StudentNavbar = ({
  navItems,
  isActive,
  navigate
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const notifications = [{
    id: 1,
    message: 'Deadline for MBA application is in 3 days',
    type: 'deadline'
  }, {
    id: 2,
    message: 'Your IELTS certificate is missing',
    type: 'document'
  }, {
    id: 3,
    message: 'New program matches your profile',
    type: 'recommendation'
  }];
  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
    setProfileOpen(false);
  };
  const toggleProfile = () => {
    setProfileOpen(!profileOpen);
    setNotificationsOpen(false);
  };
  const handleSwitchPersona = () => {
    navigate('/');
  };
  const getNotificationIcon = type => {
    switch (type) {
      case 'deadline':
        return <CalendarIcon className="w-4 h-4 text-yellow-500" data-id="element-129" />;
      case 'document':
        return <FileTextIcon className="w-4 h-4 text-red-500" data-id="element-130" />;
      case 'recommendation':
        return <GraduationCapIcon className="w-4 h-4 text-green-500" data-id="element-131" />;
      default:
        return <BellIcon className="w-4 h-4 text-primary-500" data-id="element-132" />;
    }
  };
  return <>
      {/* Desktop Navigation */}
      <div className="bg-white shadow-sm sticky top-0 z-50" data-id="element-133">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
          <div className="flex justify-between h-16" data-id="element-135">
            {/* Logo and Brand */}

            {/* Desktop Nav Links */}
            <div className="hidden md:flex md:items-center md:space-x-4" data-id="element-136">
              {navItems.map((item, index) => <a key={index} href={item.path} onClick={e => {
              e.preventDefault();
              navigate(item.path);
            }} className={`px-4 py-2 text-sm font-medium transition-colors ${isActive(item.path) ? 'text-primary-500 border-b-2 border-primary-500' : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'}`} data-id="element-137">
                  <div className="flex items-center" data-id="element-138">{item.label}</div>
                </a>)}
            </div>
            {/* Right side icons */}
            <div className="flex items-center" data-id="element-139">
              {/* Notifications */}
              <div className="relative ml-3" data-id="element-140">
                <button onClick={toggleNotifications} className="p-1 rounded-full text-gray-600 hover:text-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" data-id="element-141">
                  <span className="sr-only" data-id="element-142">View notifications</span>
                  <div className="relative" data-id="element-143">
                    <BellIcon className="h-6 w-6" data-id="element-144" />
                    <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-red-500 flex items-center justify-center text-xs text-white" data-id="element-145">
                      3
                    </span>
                  </div>
                </button>
                {/* Notifications dropdown */}
                {notificationsOpen && <div className="origin-top-right absolute right-0 mt-2 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" data-id="element-146">
                    <div className="py-1" data-id="element-147">
                      <div className="px-4 py-2 border-b border-gray-100" data-id="element-148">
                        <h3 className="text-sm font-medium text-gray-700" data-id="element-149">
                          Notifications
                        </h3>
                      </div>
                      {notifications.map(notification => <a key={notification.id} href="#" className="block px-4 py-3 hover:bg-gray-50 border-b border-gray-100 last:border-0" data-id="element-150">
                          <div className="flex items-start" data-id="element-151">
                            <div className="flex-shrink-0 mt-0.5" data-id="element-152">
                              {getNotificationIcon(notification.type)}
                            </div>
                            <div className="ml-3" data-id="element-153">
                              <p className="text-sm text-gray-700" data-id="element-154">
                                {notification.message}
                              </p>
                              <p className="text-xs text-gray-500 mt-1" data-id="element-155">
                                5 minutes ago
                              </p>
                            </div>
                          </div>
                        </a>)}
                      <div className="px-4 py-2 text-center border-t border-gray-100" data-id="element-156">
                        <a href="#" className="text-sm font-medium text-primary-500 hover:text-primary-600" data-id="element-157">
                          View all notifications
                        </a>
                      </div>
                    </div>
                  </div>}
              </div>
              {/* Profile dropdown */}
              <div className="relative ml-3" data-id="element-158">
                <button onClick={toggleProfile} className="flex items-center max-w-xs rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" data-id="element-159">
                  <span className="sr-only" data-id="element-160">Open user menu</span>
                  <div className="h-8 w-8 rounded-full bg-primary-500 flex items-center justify-center text-white" data-id="element-161">
                    SA
                  </div>
                  <ChevronDownIcon className="ml-1 h-4 w-4 text-gray-500" data-id="element-162" />
                </button>
                {profileOpen && <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" data-id="element-163">
                    <div className="py-1" data-id="element-164">
                      <a href="/student/documents" onClick={e => {
                    e.preventDefault();
                    navigate('/student/documents');
                    setProfileOpen(false);
                  }} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" data-id="element-165">
                        <FileTextIcon className="w-4 h-4 mr-2" data-id="element-166" />
                        My Documents
                      </a>
                      <button onClick={handleSwitchPersona} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" data-id="element-167">
                        <LogOutIcon className="w-4 h-4 mr-2" data-id="element-168" />
                        Switch Persona
                      </button>
                    </div>
                  </div>}
              </div>
              {/* Mobile menu button */}
              <div className="ml-2 -mr-2 flex items-center md:hidden" data-id="element-169">
                <button onClick={toggleMobileMenu} className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-primary-500 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500" data-id="element-170">
                  <span className="sr-only" data-id="element-171">Open main menu</span>
                  {mobileMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-172" /> : <MenuIcon className="block h-6 w-6" data-id="element-173" />}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile menu, show/hide based on menu state */}
        {mobileMenuOpen && <div className="md:hidden" data-id="element-174">
            <div className="pt-2 pb-3 space-y-1 border-t border-gray-200" data-id="element-175">
              {navItems.map((item, index) => <a key={index} href={item.path} onClick={e => {
            e.preventDefault();
            navigate(item.path);
            setMobileMenuOpen(false);
          }} className={`w-full flex items-center px-4 py-3 text-lg ${isActive(item.path) ? 'bg-primary-50 text-primary-500 font-medium' : 'text-gray-600 hover:bg-primary-50 hover:text-primary-600'}`} data-id="element-176">
                  <span className="mr-3" data-id="element-177">{item.icon}</span>
                  {item.label}
                  {item.badge && <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-primary-100 text-primary-800" data-id="element-178">
                      {item.badge}
                    </span>}
                </a>)}
            </div>
            <div className="pt-4 pb-3 border-t border-gray-200" data-id="element-179">
              <div className="flex items-center px-4" data-id="element-180">
                <div className="flex-shrink-0" data-id="element-181">
                  <div className="h-10 w-10 rounded-full bg-primary-500 flex items-center justify-center text-white" data-id="element-182">
                    SA
                  </div>
                </div>
                <div className="ml-3" data-id="element-183">
                  <div className="text-base font-medium text-gray-800" data-id="element-184">
                    Sarah Ahmed
                  </div>
                  <div className="text-sm font-medium text-gray-500" data-id="element-185">
                    sarah@example.com
                  </div>
                </div>
              </div>
              <div className="mt-3 space-y-1" data-id="element-186">
                <a href="#" className="block px-4 py-2 text-base font-medium text-gray-600 hover:text-primary-500 hover:bg-primary-50" data-id="element-187">
                  View Profile
                </a>
                <a href="#" className="block px-4 py-2 text-base font-medium text-gray-600 hover:text-primary-500 hover:bg-primary-50" data-id="element-188">
                  Settings
                </a>
                <a href="/" className="block px-4 py-2 text-base font-medium text-gray-600 hover:text-primary-500 hover:bg-primary-50" data-id="element-189">
                  Log Out
                </a>
              </div>
            </div>
          </div>}
      </div>
      {/* Mobile floating CTA */}
      <div className="fixed bottom-6 right-6 md:hidden z-40" data-id="element-190">
        <button className="h-14 w-14 rounded-full bg-primary-500 text-white shadow-lg flex items-center justify-center hover:bg-primary-600 transition-colors" data-id="element-191">
          <PlusCircleIcon className="h-6 w-6" data-id="element-192" />
        </button>
      </div>
    </>;
};
const CollapsibleCard = ({
  title,
  icon,
  children,
  initiallyExpanded = true,
  stats,
  action,
  className = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(initiallyExpanded);
  return <div className={`bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden ${className}`} data-id="element-193">
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-194">
        <div className="flex items-center" data-id="element-195">
          {icon}
          <h2 className="text-lg font-medium text-gray-800 ml-2" data-id="element-196">{title}</h2>
        </div>
        <div className="flex items-center space-x-2" data-id="element-197">
          {action && <button onClick={action.onClick} className="text-sm text-primary-500 hover:underline flex items-center" data-id="element-198">
              {action.label}
              <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-199" />
            </button>}
          <button onClick={() => setIsExpanded(!isExpanded)} className="text-gray-500 hover:text-gray-700" data-id="element-200">
            {isExpanded ? <ChevronUpIcon className="w-5 h-5" data-id="element-201" /> : <ChevronDownIcon className="w-5 h-5" data-id="element-202" />}
          </button>
        </div>
      </div>
      {!isExpanded && stats && <div className="p-4 flex flex-wrap gap-4" data-id="element-203">
          {stats.map((stat, index) => <div key={index} className="flex items-center" data-id="element-204">
              {stat.icon && <span className="mr-2" data-id="element-205">{stat.icon}</span>}
              <div data-id="element-206">
                <div className="text-xl font-semibold" data-id="element-207">{stat.value}</div>
                <div className="text-xs text-gray-500" data-id="element-208">{stat.label}</div>
              </div>
            </div>)}
        </div>}
      {isExpanded && <div className="p-4 h-full" data-id="element-209">{children}</div>}
    </div>;
};
const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  persona,
  universityName = 'UAE Business School'
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  // Get sidebar title and icon based on persona
  const getSidebarInfo = () => {
    switch (persona) {
      case 'Student':
        return {
          title: 'Career Navigator',
          icon: 'WS',
          iconBg: theme.colors.primary[500] // Dark blue for student
        };
      case 'Platform Admin':
        return {
          title: 'Career Navigator',
          icon: 'WS',
          iconBg: theme.colors.primary[500] // Dark blue for admin
        };
      case 'MoHESR Admin':
        return {
          title: 'Career Navigator',
          icon: 'WS',
          iconBg: theme.colors.primary[500] // Dark blue for MoHESR
        };
      case 'Company/Partner':
        return {
          title: 'Career Navigator',
          icon: 'WS',
          iconBg: theme.colors.primary[500] // Dark blue for employer
        };
      default:
        return {
          title: 'Career Navigator',
          icon: 'WS',
          iconBg: theme.colors.primary[500] // Dark blue for university
        };
    }
  };
  const {
    title: portalTitle,
    icon: portalIcon,
    iconBg
  } = getSidebarInfo();
  // Get sidebar navigation items based on persona
  const getNavItems = (): NavItem[] => {
    // Add persona-specific navigation items
    if (persona === 'Student') {
      return [{
        label: 'Dashboard',
        icon: <HomeIcon className="w-5 h-5" data-id="element-210" />,
        path: '/student'
      }, {
        label: 'Explore Programs',
        icon: <GraduationCapIcon className="w-5 h-5" data-id="element-211" />,
        path: '/student/programs'
      }, {
        label: 'Scholarships',
        icon: <BookOpenIcon className="w-5 h-5" data-id="element-212" />,
        path: '/student/scholarships',
        badge: 'New'
      }, {
        label: 'My Applications',
        icon: <FileTextIcon className="w-5 h-5" data-id="element-213" />,
        path: '/student/applications-and-scholarships'
      }];
    } else if (persona === 'Platform Admin') {
      return [{
        label: 'Overview',
        icon: <HomeIcon className="w-5 h-5" data-id="element-214" />,
        path: '/admin'
      }, {
        label: 'Universities',
        icon: <BuildingIcon className="w-5 h-5" data-id="element-215" />,
        path: '/admin/universities'
      }, {
        label: 'Programs',
        icon: <GraduationCapIcon className="w-5 h-5" data-id="element-216" />,
        path: '/admin/programs'
      }, {
        label: 'Scholarships',
        icon: <AwardIcon className="w-5 h-5" data-id="element-217" />,
        path: '/admin/scholarships',
        badge: 'New'
      }, {
        label: 'Applicants',
        icon: <UsersIcon className="w-5 h-5" data-id="element-218" />,
        path: '/admin/applications'
      }, {
        label: 'Settings',
        icon: <SettingsIcon className="w-5 h-5" data-id="element-219" />,
        path: '/admin/settings'
      }];
    } else if (persona === 'MoHESR Admin') {
      return [{
        label: 'Dashboard',
        icon: <HomeIcon className="w-5 h-5" data-id="element-220" />,
        path: '/mohesr'
      }, {
        label: 'Elite Track',
        icon: <AwardIcon className="w-5 h-5" data-id="element-221" />,
        path: '/mohesr/elite-track'
      }, {
        label: 'Eligible Lists',
        icon: <GlobeIcon className="w-5 h-5" data-id="element-222" />,
        path: '/mohesr/eligible-lists'
      }, {
        label: 'Partnership Approvals',
        icon: <CheckSquareIcon className="w-5 h-5" data-id="element-223" />,
        path: '/mohesr/partnership-approvals',
        badge: 3
      }, {
        label: 'Applications',
        icon: <FileTextIcon className="w-5 h-5" data-id="element-224" />,
        path: '/mohesr/applications'
      }, {
        label: 'Reports',
        icon: <BarChart3Icon className="w-5 h-5" data-id="element-225" />,
        path: '/mohesr/reports'
      }];
    } else if (persona === 'Company/Partner') {
      return [{
        label: 'Dashboard',
        icon: <HomeIcon className="w-5 h-5" data-id="element-226" />,
        path: '/employer'
      }, {
        label: 'My Scholarships',
        icon: <AwardIcon className="w-5 h-5" data-id="element-227" />,
        path: '/employer/scholarships'
      }, {
        label: 'Create Scholarship',
        icon: <PlusCircleIcon className="w-5 h-5" data-id="element-228" />,
        path: '/employer/create-scholarship'
      }, {
        label: 'Applications',
        icon: <FileTextIcon className="w-5 h-5" data-id="element-229" />,
        path: '/employer/applications',
        badge: 5
      }, {
        label: 'Interviews',
        icon: <CalendarIcon className="w-5 h-5" data-id="element-230" />,
        path: '/employer/interviews',
        badge: 3
      }];
    } else {
      // University Coordinator navigation - with the requested structure
      return [{
        label: 'Dashboard Overview',
        icon: <LayoutDashboardIcon className="w-5 h-5" data-id="element-231" />,
        path: '/university'
      }, {
        label: 'Programs',
        icon: <GraduationCapIcon className="w-5 h-5" data-id="element-232" />,
        path: '/university/programs'
      }, {
        label: 'Applications',
        icon: <UsersIcon className="w-5 h-5" data-id="element-233" />,
        path: '/university/applications'
      }, {
        label: 'Communications',
        icon: <MailIcon className="w-5 h-5" data-id="element-234" />,
        path: '/university/communications'
      }, {
        label: 'Reports & Insights',
        icon: <BarChart3Icon className="w-5 h-5" data-id="element-235" />,
        path: '/university/reports'
      }, {
        label: 'Profile & Settings',
        icon: <SettingsIcon className="w-5 h-5" data-id="element-236" />,
        path: '/university/settings'
      }];
    }
  };
  // Get navigation items based on persona
  const navItems = getNavItems();
  // Check if a path is active
  const isActive = (path: string) => {
    // Use the current location path for comparison
    const currentPath = location.pathname;
    // Special case for the combined applications and scholarships page
    if (path === '/student/applications-and-scholarships') {
      return currentPath === '/student/applications-and-scholarships' || currentPath === '/student/applications' || currentPath === '/student/my-scholarships';
    }
    // For exact matches
    if (path === currentPath) {
      return true;
    }
    // For parent paths that aren't the root paths
    if (path !== '/' && path !== '/student' && path !== '/admin' && path !== '/university' && path !== '/mohesr' && path !== '/employer' && currentPath.startsWith(path)) {
      return true;
    }
    // Special case for dashboard/home pages
    if (path === '/student' && currentPath === '/student' || path === '/admin' && currentPath === '/admin' || path === '/university' && currentPath === '/university' || path === '/mohesr' && currentPath === '/mohesr' || path === '/employer' && currentPath === '/employer') {
      return true;
    }
    return false;
  };
  // Get user avatar based on persona
  const getUserAvatar = () => {
    switch (persona) {
      case 'Student':
        return <UserIcon className="w-4 h-4" data-id="element-237" />;
      case 'Platform Admin':
        return <UserIcon className="w-4 h-4" data-id="element-238" />;
      default:
        return <UserIcon className="w-4 h-4" data-id="element-239" />;
    }
  };
  // Get breadcrumb based on current path
  const getBreadcrumb = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    if (pathSegments.length === 0) return null;
    return <div className="flex items-center text-sm" data-id="element-240">
        <HomeIcon className="w-4 h-4 text-gray-500" data-id="element-241" />
        {pathSegments.map((segment, index) => <Fragment key={index} data-id="element-242">
            <span className="mx-2 text-gray-400" data-id="element-243">/</span>
            <span className="capitalize text-gray-600" data-id="element-244">
              {segment.replace(/-/g, ' ')}
            </span>
          </Fragment>)}
      </div>;
  };
  // Check if we need to render a back button
  const shouldShowBackButton = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    // Don't show back button for top-level pages
    if (pathSegments.length === 1) {
      return false;
    }
    // These are the top-level paths that shouldn't show a back button
    const topLevelPaths = ['university', 'student', 'admin', 'mohesr', 'employer'];
    // If this is a sub-page of a top-level path, show the back button
    return pathSegments.length > 1 && !topLevelPaths.includes(pathSegments[0]);
  };
  // Render different layouts based on persona
  if (persona === 'Student') {
    return <div className="min-h-screen bg-secondary-50 flex flex-col" data-id="element-245">
        {/* Top Navigation for Student */}
        <StudentNavbar navItems={navItems} isActive={isActive} navigate={navigate} data-id="element-246" />
        {/* Main content */}
        <div className="flex-1" data-id="element-247">
          {/* Breadcrumb */}
          {/* Main content */}
          <main className="max-w-7xl mx-auto flex-grow p-6" data-id="element-248">
            {shouldShowBackButton() && <button onClick={() => navigate(-1)} className="mb-4 flex items-center text-sm text-gray-600 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-249">
                <ChevronLeftIcon className="w-4 h-4 mr-1" data-id="element-250" />
                Back
              </button>}
            {children}
          </main>
        </div>
      </div>;
  }
  // Original sidebar layout for other personas
  return <div className="min-h-screen bg-secondary-50 flex" data-id="element-251">
      {/* Sidebar */}
      <div className="w-64 bg-primary-600 fixed h-full z-20" data-id="element-252">
        <div className="flex items-center text-white px-4 py-6" data-id="element-253">
          Future of Work Navigator
        </div>
        <nav className="mt-4" data-id="element-254">
          <ul className="space-y-1" data-id="element-255">
            {navItems.map((item, index) => <li key={index} data-id="element-256">
                <a href={item.path} onClick={e => {
              e.preventDefault();
              navigate(item.path);
            }} className={`flex items-center px-4 py-3 text-sm transition-colors ${isActive(item.path) ? `bg-primary-700 text-white font-medium` : 'text-white hover:bg-primary-700'}`} data-id="element-257">
                  <span className={`mr-3 ${isActive(item.path) ? `text-white` : 'text-white'}`} data-id="element-258">
                    {item.icon}
                  </span>
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>
        {/* Government Emblem at bottom */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-primary-400" data-id="element-259">
          <div className="flex items-center text-white text-sm" data-id="element-260">
            <div className="w-8 h-8 rounded-full bg-white bg-opacity-10 flex items-center justify-center mr-2" data-id="element-261">
              <BuildingIcon className="w-4 h-4 text-white" data-id="element-262" />
            </div>
            <div data-id="element-263">
              <div className="text-xs" data-id="element-264">Government</div>
              <div className="font-medium" data-id="element-265">Emblem</div>
            </div>
          </div>
        </div>
      </div>
      {/* Main content */}
      <div className="flex-1 ml-64 flex flex-col" data-id="element-266">
        {/* Header */}
        <header className="bg-primary-500 sticky top-0 z-50" data-id="element-267">
          <div className="px-6 py-2 flex justify-end items-center" data-id="element-268">
            <div className="flex items-center space-x-2" data-id="element-269">
              {/* Language Selector */}
              <div className="relative" data-id="element-270">
                <button className="flex items-center px-3 py-1 text-white text-sm rounded-md border border-primary-400" data-id="element-271">
                  <span className="mr-1" data-id="element-272">EN</span>
                  <ChevronDownIcon className="w-4 h-4" data-id="element-273" />
                </button>
              </div>
              {/* Inbox */}
              <div className="relative" data-id="element-274">
                <button className="flex items-center px-3 py-1 text-white text-sm rounded-md border border-primary-400" data-id="element-275">
                  <MailIcon className="w-4 h-4 mr-1" data-id="element-276" />
                  <span data-id="element-277">Inbox: 3</span>
                </button>
              </div>
              {/* User menu */}
              <div className="relative" data-id="element-278">
                <button onClick={() => setUserMenuOpen(!userMenuOpen)} className="flex items-center px-3 py-1 text-white text-sm rounded-md border border-primary-400" data-id="element-279">
                  <UserIcon className="w-4 h-4 mr-1" data-id="element-280" />
                  <span className="mr-1" data-id="element-281">My Account</span>
                  <ChevronDownIcon className="w-4 h-4" data-id="element-282" />
                </button>
                {userMenuOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50" data-id="element-283">
                    <div className="py-1" data-id="element-284">
                      <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" onClick={() => navigate('/')} data-id="element-285">
                        <LogOutIcon className="w-4 h-4 mr-2" data-id="element-286" />
                        Switch Persona
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </header>
        {/* Breadcrumb */}
        <div className="bg-white border-b border-gray-200 px-6 py-3" data-id="element-287">
          {getBreadcrumb()}
        </div>
        {/* Main content */}
        <main className={`flex-grow ${persona === 'MoHESR Admin' || persona === 'Company/Partner' ? 'p-8' : 'p-6'}`} data-id="element-288">
          {shouldShowBackButton() && <button onClick={() => navigate(-1)} className="mb-6 flex items-center text-sm text-gray-600 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-289">
              <ChevronLeftIcon className="w-4 h-4 mr-1" data-id="element-290" />
              Back
            </button>}
          {title && <h1 className={`text-2xl font-semibold text-gray-800 ${shouldShowBackButton() ? 'mb-6' : 'mb-8'}`} data-id="element-291">
              {title}
            </h1>}
          {children}
        </main>
      </div>
    </div>;
};
export default Layout;